import { SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_LINK_REQUEST_BY_ID } from 'api/utilityActionTypes';

export default async function getLinkRequestById(
  { state, utilityApiClient },
  { activationLinkRequestId, forceRefresh = false } = {},
) {
  const currentStatePath = ['utilityActivationLinkRequests', 'byId', activationLinkRequestId];
  if (!forceRefresh && state.get(currentStatePath)) {
    return state.get(currentStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_LINK_REQUEST_BY_ID,
    state: state,
    payload: {
      activationLinkRequestId,
    },
    onSuccess(linkRequest) {
      if (linkRequest) {
        state.set(currentStatePath, linkRequest);
      }
    },
  });
}
